import { config } from '@/config/bzbsconfig.js'; // auto build use this
// import { config } from '@/config/bzbsconfig.dev.js';
import { config as configStg } from '@/config/bzbsconfig.stg.js';
// import { config } from '@/config/bzbsconfig.prd.js';

import { campaignConfig, dashboardConfig, categoryConfig, historyConfig } from './configlist';

export default {
    install(Vue) {

        if (config.debug) {
            var runLocalEnvironment = 'dev';

            switch (runLocalEnvironment) {
                case 'dev':
                    Vue.bzbsConfig = config;
                    break;
                case 'stg':
                    Vue.bzbsConfig = configStg;
                    break;
            }
        } else {
            Vue.bzbsConfig = config;
        }

        Vue.bzbsConfig.campaignConfig = campaignConfig;
        Vue.bzbsConfig.dashboardConfig = dashboardConfig;
        Vue.bzbsConfig.categoryConfig = categoryConfig;
        Vue.bzbsConfig.historyConfig = historyConfig;
    }
}
